/// <reference path="../../jquery.d.ts" />
/// <reference path="../../types/global.d.ts" />
/// <reference path="../../types/utilities.d.ts" />

declare const sumPanel: (JQuery) => void;

module PoskiQ {
    "use strict";

    export class OrderCart {
        public static Instance: OrderCart = null;
        private cartClass: string = '.js-shopping-cart';

        private cartHtmlElement: HTMLDivElement;
        private container: JQuery;
        private form: HTMLFormElement;
        private spinner: JQuery;
        private recountTimeoutHandle: number;
        public href: string;

        public constructor() {
            const containerHtmlElement = document.querySelector('.js-cart-container');
            this.cartHtmlElement = containerHtmlElement.querySelector(this.cartClass);
            this.container = $(containerHtmlElement);
            this.form = containerHtmlElement.closest('form');
            this.href = window.location.href;
            this.appendSpinner();
            this.addEventListeners();
        }

        private appendSpinner(): void {
            this.spinner = $('<div class="spinner-holder"><i class="fa fa-spinner fa-spin"></i></div>');
            this.spinner.hide();
            this.container.find(this.cartClass).append(this.spinner);
        }

        private bindRecountOnCountChange(): void {
            $('.product-recount').hide();
            this.container.find(this.cartClass + ' input[data-counter-input]').on('change', function (/*event: JQueryEventObject*/) {
                this.scheduleRecount();
            }.bind(this));
        }

        private scheduleRecount() {
            window.clearTimeout(this.recountTimeoutHandle);
            this.recountTimeoutHandle = window.setTimeout(this.submitForm.bind(this), 200);
        }

        private submitForm(): void {
            const formData = new FormData(this.form);
            formData.append('ajax-cart', '1');

            var refreshTimeout = window.setTimeout(function () { // zachranne odeslani
                this.form.submit();
            }.bind(this), 10000);

            /**
             * Hide spinneru později již není potřeba, protože spinner se apenduje do sekce,
             * která se replacne a následně se provádí nová inicializace.
             * Starý FE ještě nemá global spinner, takže se všude požívá spinnery lokální.
             */
            this.spinner.show();

            fetch(this.href, {
                method: 'POST',
                body: formData,
            })
                .then(result => result.json())
                .then((data: OrderProcessResponse) => {
                    window.clearTimeout(refreshTimeout);
                    this.onCartUpdated(data);
                });
        }

        private bindAddDiscount(): void {
            this.container.find(this.cartClass + ' .js-submit-discount').on('click', function (event: JQueryEventObject) {
                this.scheduleRecount();
                event.preventDefault();
            }.bind(this));
        }

        private bindRemoveItem(): void {
            this.container.find(this.cartClass + ' .js-product-remove').on('click', function (event: JQueryEventObject) {
                this.href = event.currentTarget.getAttribute('href');
                this.submitForm();
                event.preventDefault();
            }.bind(this));
        }

        private reRenderCart(newCartHtml: string) {
            this.cartHtmlElement.innerHTML = newCartHtml;
        }

        private onCartUpdated(data: OrderProcessResponse) {
            data.views.Cart && this.reRenderCart(data.views.Cart);
            if (data.remarketingCodes) {
                Util.appendToBody(data.remarketingCodes);
            }

            sumPanel($('[data-amount-input]'));

            OrderCart.Instance = new OrderCart(); // resetovani stranky, navazani udalosti
            EventBus.getInstance().dispatchEvent("orderStepCartUpdated", {});
        }

        private addEventListeners(): void {
            this.bindRecountOnCountChange();
            this.bindRemoveItem();
            this.bindAddDiscount();
            EventBus.getInstance().addEventListener('orderUpdateStepCart', e => this.scheduleRecount());

            this.cartHtmlElement.querySelectorAll('[data-additional-service-url]')
                .forEach((el: HTMLInputElement) => {
                    el.addEventListener('click', async (event) => {
                        this.spinner.show();

                        event.preventDefault();
                        const url = el.dataset.additionalServiceUrl;
                        const response = await fetch(url);
                        const json = await response.json();

                        this.onCartUpdated(json);
                    })
                })
        }
    }

    $(function () {
        if (!document.body.className.match(/location_order_getCart/))
            return;

        OrderCart.Instance = new OrderCart();
    });
}
